import { Controller } from "@hotwired/stimulus"

export default class ElementEnablerController extends Controller {
  static targets = ["element"]

  enable() {
    this.#targets.forEach((target) => {
      target.disabled = false
    })
  }

  disable() {
    this.#targets.forEach((target) => {
      target.disabled = true
    })
  }

  get #targets() {
    return this.hasElementTarget ? this.elementTargets : [this.element]
  }
}
